import React, { useState, useEffect } from 'react';
import { AppHeader, Button } from '@veneer/core';
import { useLocation, useNavigate } from 'react-router-dom';

function removeCookie(name, path = '/') {
    const cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path};`;
    document.cookie = cookieString; // Remove the cookie
}

// Utility function to decode Base64 URL
const base64UrlDecode = (base64Url) => {
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padding = '='.repeat((4 - base64.length % 4) % 4);
    return decodeURIComponent(escape(atob(base64 + padding)));
};

// Function to parse JWT token
const parseJwt = (token) => {
    const [header, payload] = token.split('.');
    try {
        return {
            header: JSON.parse(base64UrlDecode(header)),
            payload: JSON.parse(base64UrlDecode(payload)),
        };
    } catch (e) {
        console.error("Error parsing JWT:", e);
        return { header: null, payload: null };
    }
};

const CustomHeader = ({ setIsLoading }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isUserRoleOne, setIsUserRoleOne] = useState(false);
    const location = useLocation();
    const navigate = useNavigate(); // Hook for navigation

    useEffect(() => {
        const storedToken = getCookie('auth-token');
        if (storedToken) {
            const { header, payload } = parseJwt(storedToken);
            if ((header && header.profile === '1') || (payload && payload.profile === '1')) {
                setIsUserRoleOne(true);
            }
        }
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(prevState => !prevState);
    };

    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    };

    const handleLogout = () => {
        setIsLoading(true); // Start loading
        removeCookie('auth-token');

        localStorage.setItem('redirectURL', window.location.href);
        const logoutUrl = `${process.env.REACT_APP_PHPSC_LOGOUT_AUTH_URI}/?post_logout_redirect_uri=${process.env.REACT_APP_PHPSC_LOGOUT_REDIRECT_URI}/&state=sign_out`
            .replace(/([^:]\/)\/+/g, "$1");

        setTimeout(() => {
            window.location.href = logoutUrl;
        }, 500);
    };

    const handleUsersListClick = () => {
        navigate('/users'); // Navigate to /users
    };

    return (
        <div className="custom-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <a href="/" className="custom-header-title" style={{ textDecoration: "none", fontSize: '24px', marginRight: 'auto' }}>
                Printhead Service Code
            </a>
            {location.pathname === '/' && isUserRoleOne && (
                <Button style={{ marginRight: '50px' }} onClick={handleUsersListClick}>
                    Users List
                </Button>
            )}
            <div onClick={toggleMenu} style={{ cursor: 'pointer', position: 'relative' }}>
                <AppHeader />
                {isMenuOpen && location.pathname !== '/login' && ( // Hide on the login page
                    <div className="submenu">
                        <button onClick={handleLogout}>Logout</button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default CustomHeader;
